  
  <template>
    <ListeOperation />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumbs from "@/layout/BreadCrumbs.vue";
import ListeOperation from "@/components/GesCom/Operations/ListeOperation.vue";
  
  export default defineComponent({
    name: "ListeOperationPage",
    components: {
      BreadCrumbs,
      ListeOperation,
    },
  });
  </script>
  
  